module.exports = __webpack_public_path__ + "static/media/72774641_381121549459312_1177208131621486592_n.0a598fff.png";